import { ReactNode } from "react";

import { useAppSelector } from "../../../../hooks";
import { selectCurrentUser } from "../../services";
import { AMAZE_ACTION, AMAZE_RESOURCE, ENTERPRISE_RESOURCE } from "../../types";
import { checkEnterprisePermission, checkHasPermission } from "../../utils";
interface IProps {
    resource: AMAZE_RESOURCE;
    action: AMAZE_ACTION;
    children: ReactNode;
    fallback?: ReactNode;
    enterpriseResource?: ENTERPRISE_RESOURCE;
}

const PermissionControl = ({ resource, action, children, fallback, enterpriseResource }: IProps) => {
    const currentUser = useAppSelector(selectCurrentUser);
    const hasPermission =
        currentUser?.role === "enterprise_user" && enterpriseResource
            ? checkEnterprisePermission(currentUser.enterpriseRoles, enterpriseResource, action)
            : checkHasPermission({ role: currentUser?.role, resource, action });

    if (!hasPermission) {
        return fallback ? <>{fallback}</> : null;
    }

    return <>{children}</>;
};

export default PermissionControl;
